import React from "react";
import { MapContainer, TileLayer, Polyline, Marker, Popup } from "react-leaflet";
import L from "leaflet";

const stationIcon = L.divIcon({
  className: "cammino-station-icon",
  html: `<div style="width:22px;height:22px;background:#C99B4A;color:#1A1A1A;border:2px solid #3E5F44;border-radius:2px;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;transform:rotate(-6deg);box-shadow:0 2px 6px rgba(0,0,0,0.25);">◆</div>`,
  iconSize: [22, 22], iconAnchor: [11, 11],
});

const TappaMap = ({ waypoints, height = "360px" }) => {
  if (!waypoints || waypoints.length < 2) return null;
  const positions = waypoints.map((w) => [w.lat, w.lng]);
  const lats = positions.map((p) => p[0]);
  const lngs = positions.map((p) => p[1]);
  const center = [(Math.min(...lats) + Math.max(...lats)) / 2, (Math.min(...lngs) + Math.max(...lngs)) / 2];
  const bounds = [[Math.min(...lats), Math.min(...lngs)], [Math.max(...lats), Math.max(...lngs)]];

  return (
    <div data-testid="tappa-map" className="w-full overflow-hidden rounded-sm border border-carrubo/20" style={{ height }}>
      <MapContainer center={center} bounds={bounds} boundsOptions={{ padding: [30, 30] }} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
        <Polyline positions={positions} pathOptions={{ color: "#3E5F44", weight: 4, opacity: 0.85 }} />
        <Polyline positions={positions} pathOptions={{ color: "#C99B4A", weight: 2, opacity: 0.9, dashArray: "8, 12" }} />
        {waypoints.map((w, i) => (
          <Marker key={i} position={[w.lat, w.lng]} icon={stationIcon}>
            <Popup><div className="font-sans text-sm font-semibold text-carrubo">{w.name}</div></Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default TappaMap;
